var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.881,
    height: 13.881,
    viewBox: "0 0 13.881 13.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1698",
    "data-name": "Trazado 1698",
    d: "M11.023,8.247H9.635V5.47a.694.694,0,1,0-1.388,0v3.47a.694.694,0,0,0,.694.694h2.082a.694.694,0,0,0,0-1.388ZM8.941,2a6.941,6.941,0,1,0,6.941,6.941A6.941,6.941,0,0,0,8.941,2Zm0,12.493a5.553,5.553,0,1,1,5.553-5.553A5.553,5.553,0,0,1,8.941,14.493Z",
    transform: "translate(-2 -2)",
    fill: "#e73758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7870020d69bde554780c7c738d766151.svg";
export { ForwardRef as ReactComponent };